import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import "./ContactUsForm.scss";
//import Grid from '@material-ui/core/Grid';
//import Typography from '@material-ui/core/Typography';
//import Button from '@material-ui/core/Button';
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
//import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import FilledInput from "@material-ui/core/FilledInput";
import {
  Typography,
  Grid,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
//import AddIcon from '@material-ui/icons/Add';
import NumberFormat from "react-number-format";

const useStyles = makeStyles(theme => ({
  bomHeader: {
    marginRight: "auto"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  textFieldMessage: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    width: "100%"
  },
  dense: {
    marginTop: 16
  },
  occupationSelect: {
    width: "100%",
    minWidth: 230,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& label":{
      transform: 'translate(12px, 7px) scale(0.75)'
    }
  },
  countrySelect: {
    width: "100%",
    minWidth: 230,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& label":{
      transform: 'translate(12px, 7px) scale(0.75)'
    }
  },
  bomSummaryList: {
    //width: '100%',
    //maxWidth: 360,
    backgroundColor: theme.palette.background.paper
  }
}));

function ContactUsForm(props) {
  const classes = useStyles();
  const { setQuoteItem, pii, localeSetting } = props;
  const [values, setValues] = React.useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    comments: "",
    configured: ""
  });

  function handleChange(event, checked) {
    if (typeof checked === "undefined")
      setQuoteItem({ id: event.target.name, value: event.target.value });
    else {
      if (checked)
        setQuoteItem({ id: event.target.name, value: event.target.value });
      else setQuoteItem({ id: event.target.name, value: "No" });
    }
  }

  return (
    <React.Fragment>
      <p>
      Enter your information below and a Cree Lighting representative will get back to you.
      </p>
      <p><em>* Indicates required field</em></p>
      <div className="contact-form">
        <form className="form">
          <Grid container spacing={1}>
            {/* "privacy_policy":"Yes",
                "communication":"Yes", */}

            <Grid item xs={12} sm={4}>
              <TextField
                id="first_name"
                label="First Name"
                name="first_name"
                className={classes.textField}
                onChange={handleChange}
                InputLabelProps={{
                  shrink: true
                }}
                margin="dense"
                required="true"
                fullWidth="true"
                variant="filled"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                id="last_name"
                label="Last Name"
                name="last_name"
                className={classes.textField}
                InputLabelProps={{
                  shrink: true
                }}
                onChange={handleChange}
                margin="dense"
                fullWidth="true"
                required="true"
                variant="filled"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                id="email"
                label="Email"
                name="email"
                className={classes.textField}
                onChange={handleChange}
                InputLabelProps={{
                  shrink: true
                }}
                margin="dense"
                type="email"
                autoComplete="email"
                fullWidth="true"
                required="true"
                variant="filled"
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              {/* <TextField
                        id="phone"
                        label="Phone Number"
                        name="phone"
                        // placeholder={values.age}
                        onChange={handleChange}
                        type="number"
                        className={classes.textField}
                        InputLabelProps={{
                        shrink: true,
                        }}
                        margin="dense"
                        variant="filled"
                        fullWidth="true"
                    /> */}
              <NumberFormat
                customInput={TextField}
                id="phone"
                label="Phone Number"
                name="phone"
                onChange={handleChange}
                className={classes.textField}
                InputLabelProps={{
                  shrink: true
                }}
                margin="dense"
                variant="filled"
                fullWidth="true"
                required="true"
                format="(###) ###-####"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                id="city"
                label="City"
                name="city"
                // placeholder={values.city}
                onChange={handleChange}
                type="city"
                className={classes.textField}
                InputLabelProps={{
                  shrink: true
                }}
                margin="dense"
                variant="filled"
                required="true"
                fullWidth="true"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                id="state"
                label={localeSetting.state}
                name="state"
                // placeholder={values.state}
                onChange={handleChange}
                type="state"
                className={classes.textField}
                InputLabelProps={{
                  shrink: true
                }}
                margin="dense"
                variant="filled"
                fullWidth="true"
                required="true"
              />
            </Grid>
            {
              localeSetting.state == "Province" 
                ? <Grid item xs={12} sm={4}>
                <FormControl
                  variant="filled"
                  required="true"
                  className={classes.countrySelect}
                >
                  <InputLabel htmlFor="country">Country</InputLabel>
                  <Select
                    name="country"
                    required="true"
                    // placeholder={values.state}
                    onChange={handleChange}
                    value={pii.country}
                    input={<FilledInput name="country" id="country" />}
                  >
                    <MenuItem key="CA" value={"CA"}>
                      Canada
                    </MenuItem>
                    <MenuItem key="USA" value={"USA"}>
                      United States of America
                    </MenuItem>
                  </Select>
                </FormControl>
              </Grid> 
                : ""}
            <Grid item xs={12} sm={4}>
              <TextField
                id="company"
                label="Company"
                name="company"
                required="true"
                onChange={handleChange}
                type="text"
                className={classes.textField}
                InputLabelProps={{
                  shrink: true
                }}
                margin="dense"
                variant="filled"
                fullWidth="true"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <FormControl
                variant="filled"
                className={classes.occupationSelect}
              >
                <InputLabel htmlFor="occupation">Occupation</InputLabel>
                <Select
                  name="occupation"
                  // placeholder={values.state}
                  onChange={handleChange}
                  value={pii.occupation}
                  input={<FilledInput name="occupation" id="occupation" />}
                >
                  <MenuItem key="Architect" value={"Architect"}>
                    Architect
                  </MenuItem>
                  <MenuItem key="Lighting Designer" value={"Lighting Designer"}>
                    Lighting Designer
                  </MenuItem>
                  <MenuItem
                    key="Specifying Engineer"
                    value={"Specifying Engineer"}
                  >
                    Specifying Engineer
                  </MenuItem>
                  <MenuItem key="Rep Agent" value={"Rep Agent"}>
                    Rep Agent
                  </MenuItem>
                  <MenuItem key="End User" value={"End User"}>
                    End User
                  </MenuItem>
                  <MenuItem key="Other" value={"Other"}>
                    Other
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={12}>
              <TextField
                id="comments"
                label="Message"
                name="comments"
                // placeholder={values.company}
                onChange={handleChange}
                type="text"
                className={classes.textFieldMessage}
                InputLabelProps={{
                  shrink: true
                }}
                margin="dense"
                variant="filled"
                multiline
                rows="5"
              />
            </Grid>

            <Grid item sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="privacy_policy"
                    checked={values.privacy_policy}
                    onChange={handleChange}
                    value="Yes"
                    color="primary"
                  />
                }
                label="Privacy Policy Acknowledgment *"
              />
              <p>
                I acknowledge that I have been given access to the Ideal
                Industries, Inc.{" "}
                <a
                  href="https://www.idealindustries.com/content/idealcorp/en/privacy.html"
                  target="_blank"
                >
                  Privacy Policy
                </a>
                .
              </p>
            </Grid>

            <Grid item sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="communication"
                    checked={values.communication}
                    onChange={handleChange}
                    value="Yes"
                    color="primary"
                  />
                }
                label="Communication Acknowledgement *"
              />
              <p>
                I acknowledge that I may, and am willing to, receive future
                communications from Cree Lighting, A company of IDEAL
                INDUSTRIES, regarding this inquiry.
              </p>
            </Grid>
          </Grid>
        </form>
      </div>
    </React.Fragment>
  );
}

export default ContactUsForm;
